const filterCards = [{
    "id": 0,
    "category": "marijuana",
    "text": "Short term memory loss"
},
{
    "id": 1,
    "category": "marijuana",
    "text": "Lower math and reading scores"
},
{
    "id": 2,
    "category": "marijuana",
    "text": "Anxiety, depression and paranoia"
},
{
    "id": 3,
    "category": "marijuana",
    "text": "Low motivation"
},
{
    "id": 4,
    "category": "marijuana",
    "text": "Low attention span"
},
{
    "id": 5,
    "category": "alcohol",
    "text": "Short term memory loss"
},
{
    "id": 6,
    "category": "alcohol",
    "text": "Lower bone density from lack of water and nutrients"
},
{
    "id": 7,
    "category": "alcohol",
    "text": "Trouble sleeping"
},
{
    "id": 8,
    "category": "alcohol",
    "text": "Acid reflux"
},
{
    "id": 9,
    "category": "alcohol",
    "text": "Anxiety and depression"
},
{
    "id": 10,
    "category": "tobacco",
    "text": "Shortness of breath"
},
{
    "id": 11,
    "category": "tobacco",
    "text": "Harms performance in sports"
},
{
    "id": 12,
    "category": "tobacco",
    "text": "Trouble sleeping"
},
{
    "id": 13,
    "category": "tobacco",
    "text": "Bad breath, yellow teeth and other mouth problems"
},
{
    "id": 14,
    "category": "tobacco",
    "text": "Skin damage"
}];

export default filterCards;



// WEBPACK FOOTER //
// ./src/data/filterCards.js